import { atom } from "recoil";

const returnApiPrefix = () => {
  if (process.env.REACT_APP_PREFIX) {
    return process.env.REACT_APP_PREFIX;
  } else if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_DEVPREFIX;
  } else {
    return "";
  }
};

export const apiPrefixState = atom({
  key: "apiPrefixState",
  default: returnApiPrefix(),
});
